import { FormControl as MuiFormControl } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const FormControl = styled(MuiFormControl)<{ iserrored?: string }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  height: auto !important;
  position: unset;
  gap: ${theme.spacing.xSmall}px;

  &.with-info-icon {
    display: flex;
    align-items: flex-end;
    flex-direction: row;
    width: 100%;
    gap: ${theme.spacing.xSmall}px;
  }

  .form-control-inner {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    gap: ${theme.spacing.xSmall}px;
  }

  .info-icon-wrapper {
    margin-bottom: ${theme.spacing.half}px;
  }

  .helper-text {
    color: ${theme.baseColors.info[50]};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: normal;
    position: unset;

    &.error-text {
      color: ${theme.colors.errorLight};
    }
  }

  ${({ iserrored }) =>
    iserrored &&
    iserrored === 'true' &&
    `
      .MuiOutlinedInput-root {
        fieldset {
          border-color: ${theme.colors.textPrimary} !important;
        }
      }
    `};

  .form-control-label {
    color: ${theme.colors.btnSecondaryText};
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    position: unset;
    line-height: 22px;

    span {
      color: #ee4359;
    }
  }

  .MuiFormControl-root {
    width: 100%;
  }

  .MuiOutlinedInput-root {
    width: 100%;
    min-height: 48px;
    padding: 14px ${theme.spacing.small}px;
    border: 1px solid ${theme.colors.borderMedium};
    border-radius: ${theme.attributes.borderRadius.tertiary};
    line-height: normal;
    font-family: ${theme.typography.fontFamily.primary};
    font-weight: ${theme.typography.fontWeight.normal};
    font-size: ${theme.typography.fontSize.large};
    letter-spacing: 0.25px;
    color: ${theme.colors.legacyNeutral};

    &:hover {
      border-color: ${theme.colors.legacy6c5b67};
    }

    &.Mui-focused {
      padding: 14px ${theme.spacing.small}px !important;
      border: 1px solid ${theme.colors.cta} !important;
      border-radius: ${theme.attributes.borderRadius.tertiary} !important;
      line-height: normal !important;
      font-family: ${theme.typography.fontFamily.primary} !important;
      font-weight: ${theme.typography.fontWeight.normal} !important;
      font-size: ${theme.typography.fontSize.large} !important;
      letter-spacing: 0.25px !important;
      color: ${theme.colors.legacyWhite} !important;
      background: transparent !important;
    }

    &.Mui-disabled {
      color: ${theme.colors.white};
      -webkit-text-fill-color: ${theme.colors.white};

      .MuiOutlinedInput-input {
        &::placeholder {
          color: ${theme.colors.legacySecondary80} !important;
          -webkit-text-fill-color: ${theme.colors.legacySecondary80} !important;
          opacity: 1 !important;
        }
      }
    }

    .MuiOutlinedInput-input {
      width: 100%;
      height: 48px;
      padding: 0;
      color: ${theme.colors.legacyNeutral};

      &::placeholder {
        overflow: hidden;
        color: ${theme.colors.legacySecondary80} !important;
        -webkit-text-fill-color: ${theme.colors.legacySecondary80} !important;
        text-overflow: ellipsis;
        font-size: ${theme.typography.fontSize.xLarge};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.normal};
        line-height: normal;
        opacity: 1 !important;
      }

      &.Mui-disabled {
        color: ${theme.colors.white};
        -webkit-text-fill-color: ${theme.colors.white};
      }
    }

    fieldset {
      line-height: normal;
      font-family: ${theme.typography.fontFamily.primary};
      font-weight: ${theme.typography.fontWeight.normal};
      font-size: ${theme.typography.fontSize.large};
      letter-spacing: 0.25px;
      color: ${theme.colors.white};
      height: 48px;
      outline: none;
      border: 0;
    }

    .MuiInputAdornment-root {
      .MuiTypography-root {
        color: ${theme.baseColors.greyscale[50]} !important;
        font-family: ${theme.typography.fontFamily.primary} !important;
        font-size: ${theme.typography.fontSize.large} !important;
        font-style: normal !important;
        font-weight: ${theme.typography.fontWeight.bold} !important;
        line-height: 20px !important;
        letter-spacing: unset !important;
      }
    }
  }

  .char-counter {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;

    .char-counter-text {
      color: ${theme.colors.dropdownLabel};
      font-family: Quicksand, sans-serif;
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      text-align: right;

      &.text-danger {
        color: ${theme.colors.errorLight};
      }
    }
  }
`
